import React, { useState } from 'react';
import './startprojectaddroles.css';

const StartProjectAddRoles = ({onClose, handleAddRole}) => {
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
        
        // Prevent multiple submissions
        if (isSubmitting) {
            return;
        }
        
        try {
            setIsSubmitting(true);
            await handleAddRole(event);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="addroles-popup-container">
            <div className="addroles-popup">
                <button className='addroles-closeBtn' onClick={onClose}><i className="fa-solid fa-x" /></button>
                <div className="addroles-popupcontent">
                    <h2 style={{ fontWeight: '400' }}>Add Role</h2>
                    <form style={{ marginTop: '1rem' }} onSubmit={handleSubmit}>
                        <input 
                            type='text' 
                            className='addroles-forminput' 
                            name='roleName' 
                            placeholder='Role Name' 
                            required 
                            disabled={isSubmitting}
                        />
                        <textarea 
                            className='addroles-forminput' 
                            style={{ resize: 'vertical', maxHeight: '15rem', minHeight:'8rem' }} 
                            name='roleDesc' 
                            placeholder='Description' 
                            required 
                            disabled={isSubmitting}
                        />
                        <input 
                            type='submit' 
                            className='addroles-forminput' 
                            value={isSubmitting ? 'Adding...' : 'Add'} 
                            style={{ 
                                backgroundColor: '#09CE78', 
                                color: 'white', 
                                paddingTop: '0.6rem', 
                                paddingBottom: '0.6rem', 
                                marginTop: '1rem',
                                opacity: isSubmitting ? 0.7 : 1,
                                cursor: isSubmitting ? 'not-allowed' : 'pointer'
                            }} 
                            disabled={isSubmitting}
                        />
                    </form>
                </div>
            </div>
        </div>
    );
};

export default StartProjectAddRoles;
